import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader } from "../components";
import { client as supabase } from "../utils/supabase";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const token_hash = searchParams.get("token");
    const type = searchParams.get("type");

    if (token_hash && type === "magiclink") {
      supabase.auth.verifyOtp({ token_hash, type: "magiclink" }).then(({ data, error }) => {
        if (error) {
          // eslint-disable-next-line no-console
          console.error("Error verificando magic link:", error);
          navigate("/login");
        } else {
          // RECARGA FORZADA → AuthProvider detecta la sesión y entra
          window.location.replace("/admin");
        }
      });
    } else {
      navigate("/login");
    }
  }, [navigate]);

  return <Loader fullPage />;
}
